import { Injectable, signal } from '@angular/core';

export interface Toast {
  id: number;
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts = signal<Toast[]>([]);
  private nextId = 0;
  private readonly MAX_TOASTS = 5;

  success(message: string): void {
    this.add(message, 'success', 4000);
  }

  error(message: string): void {
    this.add(message, 'error', 6000);
  }

  warning(message: string): void {
    this.add(message, 'warning', 6000);
  }

  info(message: string): void {
    this.add(message, 'info', 4000);
  }

  dismiss(id: number): void {
    this.toasts.update(list => list.filter(t => t.id !== id));
  }

  private add(message: string, type: Toast['type'], duration: number): void {
    const id = this.nextId++;
    this.toasts.update(list => {
      const updated = [...list, { id, message, type }];
      return updated.length > this.MAX_TOASTS ? updated.slice(updated.length - this.MAX_TOASTS) : updated;
    });
    setTimeout(() => this.dismiss(id), duration);
  }
}
